import { useEffect, useState } from "react";
import styled from "styled-components";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { FaInfoCircle } from "react-icons/fa";

export default function MaintenanceBanner() {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = onSnapshot(
            doc(db, "siteConfig", "maintenance"),
            (snap) => {
                if (snap.exists()) {
                    const data = snap.data();
                    setConfig(data);
                } else {
                    setConfig(null);
                }
                setLoading(false);
            },
            (error) => {
                console.error("Error loading banner config:", error);
                setLoading(false);
            }
        );
        return () => unsub();
    }, []);

    if (loading) return null; // Don't show anything while loading
    if (!config) return null; // Document doesn't exist
    if (!config.enabled) return null;

    const now = new Date();
    // Handle Firestore Timestamps - they have a toDate() method
    const start = config.startAt
        ? (config.startAt.toDate ? config.startAt.toDate() : new Date(config.startAt))
        : null;
    const end = config.endAt
        ? (config.endAt.toDate ? config.endAt.toDate() : new Date(config.endAt))
        : null;

    if (start && now < start) return null;
    if (end && now > end) return null;

    return (
        <Banner role="alert">
            <BannerInner>
                <InfoIcon />
                <Text>
                    <strong>{config.title}:</strong> {config.message}
                </Text>
            </BannerInner>
        </Banner>
    );
}


const Banner = styled.div`
  background-color: #eff6ff;
  border-bottom: 1px solid #dbeafe;
  transition: background-color 0.2s ease;

  html.dark & {
    background-color: #1e293b;
    border-bottom-color: rgba(30, 58, 138, 0.3);
  }
`;

const BannerInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const InfoIcon = styled(FaInfoCircle)`
  font-size: 20px;
  color: #3b82f6;

  html.dark & {
    color: #60a5fa;
  }
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #1e3a8a;

  html.dark & {
    color: #e0f2fe;
  }

  strong {
    font-weight: 700;
  }
`;